<template>
  <div class="energyCon">
    <div class="energy pot1">
      <home-part title="本月耗电占比" :e-title="'Power Consumption Ratio'">
        <template #icon>
          <IconSet name="clock" />
        </template>
        <template v-slot:content>
          <SkeletonLoader v-if="mouthLoading" mode="mixed" />
          <div v-else class="mouthPart">
            <div class="energyList">
              <div class="sumItem" v-for="(item , index) in left5" :key="index">
                <div class="bigCir" :style="{background: colorList[index]}"></div>
                <div class="abnormalName">{{ item.deptName}}</div>
                <div class="abnormalNum">
                  <span :style="{ fontSize: numSize(item.deptEnergy) }">{{ numFmt(item.deptEnergy) }}</span>
                </div>
              </div>
            </div>
            <div class="energyPie">
              <div class="piePart">
                <RingPureColor :data="EnergyMouthData" :colors="colorList" :inner-radius="60" :outer-radius="70"/>
                <div class="pieText">
                  <div>整体用电量</div>
                  <div class="pieNum" :style="{ fontSize: pieNumSize }">{{ pieNumText }}</div>
                </div>
              </div>
              <img class="imgPart" src="../../assets/images/h5/bigbom.webp" alt=""/>
            </div>
            <div class="energyList">
              <div class="sumItem" v-for="(item , index) in right5" :key="index">
                <div class="bigCir" :style="{background: colorList[index + 5]}"></div>
                <div class="abnormalName">{{ item.deptName}}</div>
                <div class="abnormalNum">
                  <span :style="{ fontSize: numSize(item.deptEnergy) }">{{ numFmt(item.deptEnergy) }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </home-part>
    </div>

    <div class="energy pot2">
      <home-part title="企业排碳排名" :e-title="'Ranking of enterprise carbon emissions'">
        <template #icon>
          <IconSet name="carbon" />
        </template>
        <template v-slot:content>
          <SkeletonLoader v-if="carbonLoading" mode="list" />
          <div v-else class="rank-list">
            <div class="rank-row" v-for="(item, index) in carbonList" :key="index">
              <div class="rank-row-inner">
                <div class="rank-left">
                  <IndexBadge>{{ index + 1 }}</IndexBadge>
                  <span class="rank-name">{{ item.name }}</span>
                </div>
                <div class="rank-right">
                  <span class="rank-num">{{ numFmt(item.value) }}</span>
                  <span class="rank-unit">kg</span>
                </div>
              </div>
              <div class="rank-bar-wrap">
                <div class="rank-bar-fill" :style="{ width: pct(item.value) }">
                  <div class="rank-bar-dot"></div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </home-part>
    </div>

    <div class="energy pot3">
      <home-part title="用电趋势" :e-title="'Electricity Trend'">
        <template #icon>
          <IconSet name="trend-line" />
        </template>
        <template v-slot:more>
          <div class="date-switch">
            <div v-for="(t,i) in tabs" :key="i" class="date-btn" :class="{ active: current === i }" @click="onChange(i)">
              {{ t }}
            </div>
          </div>
        </template>
        <template v-slot:content>
          <SkeletonLoader v-if="trendLoading" mode="bar" :rows="3" :row-height="8" :gap="6" />
          <ElectricityChart v-else :data="energyTrendList" />
        </template>
      </home-part>
    </div>
  </div>
</template>

<script>
import HomePart from "@/components/h5/homePart.vue";
import ElectricityChart from "@/components/h5/ElectricityChart.vue";
import RingPureColor from "@/components/h5/RingPureColor.vue";
import IndexBadge from "@/components/h5/IndexBadge.vue"
import IconSet from "@/components/h5/IconSet.vue"
import SkeletonLoader from "@/components/h5/SkeletonLoader.vue"
import { numFmt, numSize, fluidSize } from "@/utils/fmt";

export default {
  components: {
    HomePart,
    ElectricityChart,
    RingPureColor,
    IndexBadge,
    IconSet,
    SkeletonLoader,
  },
  props: {
    CarbonData:{
      type: Array,
      default: () => []
    },
    energyTrendList:{
      type:Array,
      default: () => []
    },
    energyValue: {
      type: Number,
      default: 0
    },
    mouthData: {
      type:Array,
      default: () => []
    },
    allEnergy: {
      type:Number,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    mouthLoading: { type: Boolean, default: false },
    carbonLoading: { type: Boolean, default: false },
    trendLoading: { type: Boolean, default: false },
  },
  data(){
    return{
      tabs: ['日', '月', '年'],
      colorList:['#198BFF','rgba(28, 223, 248, 1)','#0CFFC0','#FFAF45','#08979C','#722ED1','#FA541C','#35B3D2','#EB35D3','#A75B43','rgba(50, 100, 20, 1)'],
    }
  },
  methods: {
    onChange(idx) {
      this.current = idx;
      this.$emit('change', idx)
    },
    pct(v) {
      const max = this.carbonList.reduce((a, b) => Math.max(a, b.value), 0)
      return max > 0 ? (v / max * 100).toFixed(1) + '%' : '0%'
    },
    numFmt,
    numSize,
  },
  computed: {
    carbonList(){
      return this.CarbonData.map(item => ({
        name: item.deptName,
        value: item.deptCarbon
      }))
    },
    current: {
      get() {
        return this.energyValue
      },
      set(val) {
        this.$emit('update:energyValue', val)
      }
    },
    EnergyMouthData() {
      return this.mouthData.map(item => ({
        name: item.deptName,
        value: Number(item.deptEnergy) || 0
      })
      )
    },
    left5(){
      return this.mouthData.slice(0,5);
    },
    right5(){
      return this.mouthData.slice(5,10);
    },
    // ponytail: 整体用电量数字用 numFmt 转换后显示，避免超出饼图
    pieNumText() {
      return numFmt(this.allEnergy)
    },
    // ponytail: 无极字号——字符越多字号越小，完全贴合饼图半径
    pieNumSize() {
      return fluidSize(this.pieNumText)
    }
  },
}
</script>

<style scoped lang="less">
.energyCon{
  width: 100%;
  height: 100%;
  min-width: 1500px;
  min-height: 0;
  display: flex;
  gap: 20px;
}

.energy{
  display: flex;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  padding: 0;
}

.pot1{
  flex: 3;
  height: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;
}

.mouthPart{
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;
}

.energyList{
  flex: 1;
  height: 100%;
  min-width: 0;
  min-height:0;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: white;
  font-size: 12px;
  font-family: AlibabaPuHuiTi-2-55-Regular, sans-serif;
}

.sumItem{
  width: 100%;
  height: 20%;
  min-width: 0;
  min-height: 0;
  background: rgba(42, 54, 68, 0.4);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}

.abnormalName{
  flex: 1;
  text-align: left;
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.abnormalNum{
  width: 25%;
  min-width: 0;
  text-align: right;
}

.bigCir{
  width: 8px;
  height: 8px;
  border-radius: 4px;
}

.energyPie{
  width: 30%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  position: relative;

  .piePart{
    height: 80%;
    width: 100%;
    min-height: 0;
    min-width: 0;
    position:relative;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5
  }

  .pieText{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: "AlibabaPuHuiTi-2-65-Medium", sans-serif;
    font-size: 12px;
    color: #FFFFFF;
  }

  .pieNum{
    font-family: "FROSTBITE-Narrow", sans-serif;
    line-height: 28px;
    font-size: 22px;
    color: #FFFFFF;
  }

  .imgPart{
    position: absolute;
    transform: translateX(-50%);
    left: 50%;
    bottom: 0;
    width: 120px;
    height: 90px;
    z-index: 1
  }
}


.pot2{
  flex: 2;
  height: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;

  .gradeTop{
    width: 360px;
    min-height: 200px;
    margin: 20px auto;
    border: 1px solid white;
  }
}

.rank-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 6px;
  height: 100%;
  overflow: auto;
}

.rank-row {
  display: flex;
  flex-direction: column;
  padding: 3px 0 1px;
  gap: 2px;
}

.rank-row-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.rank-left {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  flex: 1;
}

.rank-name {
  font-family: "AlibabaPuHuiTi-2-55-Regular", sans-serif;
  font-size: 12px;
  color: rgba(208, 222, 238, 0.9);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.rank-right {
  display: flex;
  align-items: baseline;
  gap: 3px;
  flex-shrink: 0;
  margin-left: 8px;
}

.rank-num {
  font-family: "FROSTBITE-Narrow", sans-serif;
  font-size: 15px;
  color: #fff;
  letter-spacing: 0.3px;
}

.rank-unit {
  font-family: "AlibabaPuHuiTi-2-55-Regular", sans-serif;
  font-size: 10px;
  color: rgba(108, 128, 151, 0.7);
}

.rank-bar-wrap {
  width: 100%;
  height: 3px;
  background: rgba(42, 98, 255, 0.06);
  border-radius: 2px;
  overflow: hidden;
}

.rank-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #2A62FF 0%, rgba(42, 98, 255, 0.3) 100%);
  border-radius: 2px;
  position: relative;
  transition: width 0.4s ease;
}

.rank-bar-dot {
  position: absolute;
  right: -4px;
  top: -3px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #2A62FF;
  box-shadow: 0 0 6px rgba(42, 98, 255, 0.6);
}

.pot3{
  flex: 2;
  height: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;
  box-sizing: border-box;
}

.date-switch {
  display: flex;
  gap: 6px;
  user-select: none;
}
.date-btn {
  width: 61px;
  height: 26px;
  line-height: 24px;
  text-align: center;
  background: rgba(208, 222, 238, 0.1);
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  transition: all 0.2s;

  &.active {
    color: rgba(255, 255, 255, 1);
    text-shadow: 0 0 9px var(--color-dark-accent-glow, rgba(42,98,255,0.5));
    background: linear-gradient(180deg, rgba(234, 241, 248, 0.1) 0%, rgba(208, 222, 238, 0.1) 100%);
    border: 1px solid var(--color-primary, #2A62FF);
  }

  &:hover:not(.active) {
    color: rgba(255, 255, 255, 0.8);
  }
}
</style>
